import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app-state/app-state';
import { locsAdapter } from './locations.reducer';
import { LocationsState } from './locations.state';

export const getLocationsState = createFeatureSelector<LocationsState>('locations');

export const getLocationsCollection = locsAdapter.getSelectors(getLocationsState).selectAll;

export const getFoundLocations = createSelector(getLocationsState, (state: LocationsState) => state.foundLocations);

export const getLocationsFromCategoryGetter = createSelector(getLocationsState, (state: LocationsState) => state.fromCategory);

export const getLoadingLocations = createSelector(getLocationsState, (state: LocationsState) => state.loading);

export const getLoadedLocations = createSelector(getLocationsState, (state: LocationsState) => state.loaded);

export const getLocationsEntities = locsAdapter.getSelectors(getLocationsState).selectEntities;

export const getCreatedLocationId = createSelector(getLocationsState, (state: LocationsState) => state.createdLocationId);

export const getUpdatedLocationId = createSelector(getLocationsState, (state: LocationsState) => state.updatedLocationId);

export const getCreatedLocation = createSelector(getLocationsEntities, getCreatedLocationId, (entities, id) => {
	return id != null ? entities[id] : undefined;
});

export const getUpdatedLocation = createSelector(getLocationsEntities, getUpdatedLocationId, (entities, id) => {
	return id != null ? entities[id] : undefined;
});
export const getLocationById = (id: number) => (state: AppState) => state.locations.entities[id];

// LocationWithPinnable selectors
export const getLocationsWithPinnables = createSelector(getLocationsState, (state: LocationsState) => state.locationsWithPinnables);

export const getLocationWithPinnable = (id: number) => createSelector(getLocationsWithPinnables, (ls) => ls.find((l) => l.id === id));

export const getLocationsWithPinnablesLoading = createSelector(getLocationsState, (state: LocationsState) => state.locationsWithPinnablesLoading);

export const getLocationsWithPinnablesLoaded = createSelector(getLocationsState, (state: LocationsState) => state.locationsWithPinnablesLoaded);
